import React, { useContext, useEffect, useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useLocation, useNavigate } from 'react-router-dom';

import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FormHeader from '../../Containers/ApplicationForm/Components/FormHeader';
import { useApplicationContext } from '../../Context/applicationContext';
import { AuthContext } from '../../Context/authContext';
import { UploadDocumentContextProvider } from '../../Context/uploadDocumentContext';
import {
  getCurrentStepPayload,
  getVisibleSteps,
} from '../../Utils/Helpers/applicationHelper';
import { FORM_VALUES_COLLEGE } from '../../Utils/Helpers/formValuesHelper';
import { getApplicationByApplicationId } from '../../Utils/apiServices';
import CustomizedSteppers from '../KenApplicationForm/Components/KenStepperHeader';
import KenApplicationFormHeader from '../KenApplicationFormHeader';
import KenDialog from '../KenDialog';
import InstructionsStep from './InstructionsStep';
import Stepper from './Stepper';

export default function KenApplication() {
  const navigate = useNavigate();
  const formRef = useRef();
  const { t } = useTranslation();
  const [loader, setLoader] = useState();
  const urlSearch = useLocation().search;
  const [dialog, setDialog] = useState();

  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);

  const { applicationState, applicationDispatch } = useApplicationContext();

  const {
    formId,
    applicationId,
    applicationData,
    form,
    steps = [],
    activeStep,
    showHeader,
  } = applicationState;

  const [isDataFetched, setDataFetched] = useState();

  //update context state
  const updateState = (payload) => {
    applicationDispatch({ type: 'update', payload });
  };

  const goToDashboard = () => {
    navigate('/home');
  };

  // TODO: Implement alert/toast
  const alertMessage = (message) => {
    console.log('alert:', message);
  };

  // update applicant id to context
  useEffect(() => {
    updateState({ applicantId: user?.applicantId });
  }, [user]);

  // get formid and applicationid from query
  useEffect(() => {
    console.log('KenAppli useEffect: urlSearch :', urlSearch);
    const query = new URLSearchParams(urlSearch);

    const tempId = query.get('formId');

    if (tempId && tempId !== 'null' && tempId !== 'undefined') {
      //update formId in context
      console.log('Inside');
      updateState({ formId: tempId });
    } else {
      // alert user that form is invalid
      alertMessage('Invalid formId. Try again');
      // redirect to dasboard
      // goToDashboard();
    }

    const id = query.get('applicationId');
    if (id) {
      console.log('Inside');
      updateState({ applicationId: id });
    }
  }, [urlSearch]);

  //actions to be performed if applicationId
  useEffect(() => {
    setLoader(true);
    console.log('appId: ', applicationId);
    if (!applicationId) {
      const steps = getVisibleSteps();
      updateState({
        activeStep: 0,
        steps,
        totalSteps: steps.length,
        formOptions: {
          college: FORM_VALUES_COLLEGE,
        },
      });
      // setDataFetched(true);
      setLoader(false);
      return;
    }

    getApplicationByApplicationId(applicationId)
      .then((res) => {
        // if success update context else throw alert to refresh
        console.log(
          'ApplicationData: currentStep ',
          parseInt(res?.data?.application?.Current_Step__c) || 0
        );
        if (res?.success && res?.data) {
          const steps = getVisibleSteps();
          updateState({
            applicationData: res?.data,
            activeStep: parseInt(res?.data?.application?.Current_Step__c) || 0,
            steps,
            totalSteps: steps.length,
            applicationId: res?.data?.Id,
            formOptions: {
              college: FORM_VALUES_COLLEGE,
            },
          });
          setLoader(false);
          setDataFetched(true);
        }
      })
      .catch((err) => {
        const { response: { status, data: { errorMessages = [] } = {} } = {} } =
          err;
        console.log('application err: ', err);
        if (status === 400 && errorMessages?.length > 0) {
          //check if invalid application
          const errObj = errorMessages.find(
            (el) => (el.errorMessage = 'Wrong application Id.')
          );
          if (errObj) {
            goToDashboard();
            alertMessage(t('message:Application_Invalid'));
          }
        }
      });
  }, [applicationId, urlSearch]);

  // if formId or applicationId not valid redirect to dashboard

  // Footer next handler:
  // submit form
  const handleNext = (e) => {
    // applicationDispatch({ type: 'nextStep' })

    // triggering submit
    formRef?.current?.dispatchEvent(
      new Event('submit', { cancelable: true, bubbles: true })
    );
  };

  const handlePrev = (e) => {
    applicationDispatch({ type: 'prevStep' });
  };

  //Step changes:
  // change json tempate for formBuilder/stepcontent by active step
  // useEffect(() => {
  //   console.log('active step, steps change: ');
  // }, [activeStep, steps]);

  //onSave
  // no validations >>
  // get values from context and call api

  const handleSave = (formValues = {}) => {
    // If any errors in form show alert message

    // payload based on the current steps and sections
    const payload = getCurrentStepPayload(
      formValues,
      applicationData,
      steps,
      activeStep
    );

    // filter undefined objects

    // call api to update the

    // on error alert to enter all the mandatory fields
  };

  // TODO: input event to be replaced with formValues
  const handleSubmit = (e) => {
    console.log('submitted:');

    const formValues = {};

    const payload = getCurrentStepPayload(
      formValues,
      applicationData,
      steps,
      activeStep
    );
    console.log(payload);
    // TODO: call api to update

    // TODO: remove below
    e.preventDefault();
  };

  console.log(applicationId, applicationData, isDataFetched, loader);

  return (
    <div>
      <FormHeader />
      {showHeader && (
        <>
          {form?.programName !== null ? (
            <KenApplicationFormHeader
              programName={form?.programName}
              duration={form?.courseDuration}
              batch={form?.courseBatch}
              endDate={form?.endDate}
              form={form?.formName}
            />
          ) : (
            <Skeleton
              height="8px"
              style={{
                marginTop: '70px',
                marginBottom: '20px',
                background: '#F6C445',
              }}
            />
          )}
        </>
      )}
      {/* Add condition when application data is fetched */}
      {/* Render instruction for first time when no application id found */}
      {!applicationId &&
        applicationData === null &&
        !isDataFetched &&
        loader === false && <InstructionsStep />}
      {isDataFetched && (
        <>
          <CustomizedSteppers activeStep={activeStep} steps={steps} />
          <UploadDocumentContextProvider>
            <Stepper step={steps[activeStep]} formRef={formRef} />
          </UploadDocumentContextProvider>
        </>
      )}
      {(applicationId && !applicationData) ||
        (loader && (
          <Container maxWidth="md" style={{ textAlign: 'start' }}>
            <Skeleton
              width="40%"
              height="30px"
              style={{ marginTop: '50px', marginBottom: '20px' }}
            />
            <Skeleton
              count={2}
              inline
              width="45%"
              wrapper={({ children }) => (
                <span style={{ marginRight: '0.5rem' }}>{children}</span>
              )}
            />

            <Skeleton
              width="40%"
              height="30px"
              style={{ marginTop: '50px', marginBottom: '20px' }}
            />
            <Skeleton
              count={2}
              inline
              width="45%"
              wrapper={({ children }) => (
                <span style={{ marginRight: '0.5rem' }}>{children}</span>
              )}
            />
          </Container>
        ))}
      <KenDialog
        open={dialog}
        dialogActions={true}
        positiveButtonProps={{
          style: {
            color: '#fff',
            backgroundColor: '#092682',
            borderRadius: '4px',
            '&:hover': {
              cursor: 'pointer',
              background: '#DFE8FF',
              color: '#505F79',
            },
            padding: '8px 22px',
            fontSize: 14,
            marginBottom: 16,
          },
        }}
        positiveButtonText={'Logout'}
        positiveButtonLabelProps={{
          style: {
            color: '#fff',
          },
        }}
        hideNegativeButton={true}
        positiveButtonClick={() => {
          // sameApplicationData && goToSameApplication();
          dispatch({
            type: 'LOGOUT',
            payload: {
              user: {},
              token: null,
            },
          });
        }}
      >
        <Typography fontSize={16} fontWeight={500}>
          Applications are now closed.
        </Typography>
      </KenDialog>
    </div>
  );
}
